import AxiosInstance from "services/api";

export const TreasuryInventorySheetService = {
  async getPaginate(query) {
    return await AxiosInstance.get("/private/treasury-inventory-sheet", { params: query });
  },
  async getById(id) {
    return await AxiosInstance.get(`/private/treasury-inventory-sheet/${id}`);
  },
  async create(payload) {
    return await AxiosInstance.post("/private/treasury-inventory-sheet", payload);
  },
  async update(id, payload) {
    return await AxiosInstance.patch(`/private/treasury-inventory-sheet/${id}`, payload);
  },
  async delete(id) {
    return await AxiosInstance.delete(`/private/treasury-inventory-sheet/${id}`);
  },
};
